import { render, staticRenderFns } from "./import-xml.vue?vue&type=template&id=5cffa856"
import script from "./import-xml.vue?vue&type=script&lang=js"
export * from "./import-xml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports